/**
 * Copyright (c) [2024] Jangouts
 *
 * This software may be modified and distributed under the terms
 * of the MIT license.  See the LICENSE.txt file for details.
 */

import React from 'react';
import { Users } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import { classNames } from '../../../utils/common';

function ContactsButton({className, iconStyle}) {
  const label = "Contacts";
  const navigate = useNavigate();

  return (
    <button
      title={label}
      aria-label={label}
      className={className}
      onClick={() => navigate('/contacts')}>
      <Users className={classNames("text-secondary", iconStyle)} />
    </button>
  );
}

export default ContactsButton;